import React from 'react';
import axios from 'axios';

//CORE COMPONENTS
import { ThemeProvider, styled } from '../../../components-core/packages/components-core/dist/theme-provider';
import { 
    Container, 
    ContainerGutter, 
    ContainerWrap, 
    ContainerPadding,
    ContainerHorizontalAlignment
} from '../../../components-core/packages/components-core/dist/container';
import { Layout } from '../../../components-core/packages/components-core/dist/layout';
import { Text, TextAppearance, TextColor } from '../../../components-core/packages/components-core/dist/text';
import { Link } from '../../../components-core/packages/components-core/dist/link';
import { Breakpoints } from '../../../components-core/packages/components-core/dist/helpers';


class LegalCredits extends React.Component {

    renderCredits() {
        let splittedText;

        try {
            splittedText = this.props.custom.split('//');
        } catch (e) {
            console.log(e);
        }

        return splittedText.map(text => text &&
            <Text appearance={TextAppearance.copy0200} color={TextColor.secondary}>
                {text}
            </Text>
        )
    }

    render() {
        return (
            <Container padding={containerPadding} wrap={ContainerWrap.always} gutter={ContainerGutter.dynamic0100}>
                {this.renderCredits()}
            </Container>
        )
    }
}

const containerPadding = {
    left: {
        [Breakpoints.default]: ContainerPadding.grid002,
        [Breakpoints.b960]: ContainerPadding.grid004
    },
    right: {
        [Breakpoints.default]: ContainerPadding.grid002,
        [Breakpoints.b960]: ContainerPadding.grid004
    }, 
}

export default LegalCredits;
